import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import { WeightUnit } from '@/types';


export type Item = {
    id: string;
    name: string;
    memo: string;
    isActive: boolean;
}


@Component({
    components: {
        Modal
    }
})
export default class HarvestShippingModal extends Vue {
    
    private list: any | null = null
    private title = '収穫・出荷'
    private isLoading = false
    private menuId = ''
    private menuTitle? = '計測タイミング'
    private menu = [
        {
            id: 'measurement_timings',
            name: '計測タイミング'
        },
        {
            id: 'quality_standards',
            name: '品質・規格'
        },
        {
            id: 'weight_units',
            name: '単位'
        }
    ]
    private items = []
    private withHidden = false
    private isEdit = false
    private newName = ''
    private newWeightPerUnit?: number | null = null
    private itemId?: string | null = ''
    private isAdd = false
    private isWeightUnits = false
    private baseUrl = ''
    private alteredHarvestShipping = false
    private id!: string

    @Prop() 
    isShowHarvestShippingModal!: boolean

    @Watch('isShowHarvestShippingModal')
    private showHarvestShipping() {
        this.isLoading = true
        if(this.id) this.menuId = this.id
        this.$apiClient.getUserProfile().then(ret => {
            if (ret.role.includes('ADMIN') &&
                !this.menu.some(m => m.id === 'shipping_destinations')) {
                this.menu.push(
                    { 
                        id: 'shipping_destinations', 
                        name: '出荷先' 
                    });
            }
        }).finally(() => {
            this.isLoading = false
            this.setMenu('measurement_timings',false);
        })
    }

    @Watch('isShowHarvestShippingModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    @Watch('id')
    private onChangeId() {
        this.withHidden = false
        this.isWeightUnits = false
        this.isAdd = false
        this.isEdit = false
        this.newName = ''
        this.newWeightPerUnit = null
    }

    private init() {
        this.isAdd = false
        this.isEdit = false
        this.newName = ''
        this.newWeightPerUnit = null
    }

    private setMenu(item: string,flag:boolean) {
        if (item === this.menuId) {
            return;
        }
        this.inputChangedcheck()
        if(this.alteredHarvestShipping == false){
            this.menuId = item
            this.menuTitle = this.menu.find(elm => elm.id == item)?.name
            this.getItems(this.withHidden)
            this.init();
            if(flag){
                this.openSideBar();
            }
        }
    }

   private isActive(id: string) {
        this.items?.forEach((item: any) => {
            item.isActive = item.id === id;
        });
    }

    private getItems(withHidden: boolean) {
        let url = '/' + this.menuId
        if(this.menuId == 'shipping_destinations') url = '/admin/' + this.menuId
        this.baseUrl = url
        if(withHidden) url += '?with_hidden=' + withHidden
        this.$apiClient.doRequest('get', url).then(ret => {
            this.items = ret[this.menuId]
            this.isWeightUnits = (this.menuTitle == '単位')
        }).catch(error => {
            this.items = []
        })
    }
    
    private addItems() {
        this.isAdd = true
    }

    private edit(item: WeightUnit) {
        this.itemId = item.id
        this.isEdit = true
        this.newName = item.name
        this.newWeightPerUnit = item.weight_per_unit
    }

     private cancelEdit() {
        if (this.alteredHarvestShipping) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.alteredHarvestShipping = false;
        this.init()
    }

    private onChangeWithHidden() {
        this.withHidden = !this.withHidden
        this.getItems(this.withHidden)
    }

    private validate() {
        const errmsg: string[] = []

        // 名前
        if(!this.newName.trim()){
            errmsg.push(`${this.menuTitle}名を入力してください。`)
        }

        // 名前の長さ
        if(this.newName.length > 255){
            errmsg.push(`255文字以内で名前を入力してください（現在は${this.newName.length}文字）`)
        }

        // 数量
        if(this.isWeightUnits && this.newWeightPerUnit){
            const isMinus: boolean = /-/.test(this.newWeightPerUnit.toString())
            const integer: string = this.newWeightPerUnit.toString().split('.')[0]
            const decimal: string = this.newWeightPerUnit.toString().split('.')[1]
            if(isMinus || this.newWeightPerUnit == 0 || integer.length > 7 || decimal && decimal.length > 3){
                errmsg.push('重量は0より大きい整数部7桁小数部3桁までの数値を入力してください。')
            }
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        return true
    }

    private doAdd() {
        if(!this.validate()) {
            return
        }
        this.isLoading = true
        const params: WeightUnit = {
            name: this.newName.trim(),
            is_hidden: false
        }
        if(this.isWeightUnits) params.weight_per_unit = this.newWeightPerUnit
        const url = this.baseUrl
        this.save('post', url, params)
        this.alteredHarvestShipping = false;        
    }

    private doUpdate(item: WeightUnit) {
        if(!this.validate()) {
            return
        }
        const result = window.confirm('内容を上書きして保存します。よろしいですか。')
        this.isLoading = true
        if (!result) {
            this.isLoading = false
            return false;
        }
        const params: WeightUnit = {
            name: this.newName.trim(),
            is_hidden: item.is_hidden
        }
        if(this.isWeightUnits) {
            params.weight_per_unit = this.newWeightPerUnit
        }
        const url = `${this.baseUrl}/${item.id}`
        this.save('put', url, params)
        this.alteredHarvestShipping = false;  
    }

    private updateIsHidden(item: WeightUnit, isHidden: boolean) {
        let confirmMessage = `${item.name}を表示状態に戻します。よろしいですか？`
        if (isHidden) {
            confirmMessage = `${item.name}を非表示にします。よろしいですか？`
        }
        const result = window.confirm(confirmMessage)
        this.isLoading = true
        if (!result) {
            this.isLoading = false
            return false;
        }
        const params: WeightUnit = {
            name: item.name,
            is_hidden: isHidden
        }
        if(this.isWeightUnits) {
            params.weight_per_unit = item.weight_per_unit
        }
        const url = `${this.baseUrl}/${item.id}`
        this.save('put', url, params)
    }

    private save(method: 'post' | 'put', url: string, params: WeightUnit) {
        let toastedMessage = ''
        let toastedErrorMessage = ''
        switch (method) {
            case 'post':
                toastedMessage = '追加しました。'
                toastedErrorMessage = '追加に失敗しました。'
                break
            case 'put':
                toastedMessage = '変更しました。'
                toastedErrorMessage = '変更に失敗しました。'
                break
        }
        this.$apiClient.doRequest(method, url, params).then(() => {
            this.$toasted.success(toastedMessage)
            this.getItems(this.withHidden)
        }).catch(() => {
            this.$toasted.error(toastedErrorMessage)
        }).finally(() => {
            this.isLoading = false
            this.init()
        })

    }

  @Emit('inputChanged')
    inputChanged(){
        if(this.alteredHarvestShipping == false){
            this.alteredHarvestShipping = true
        }
    }

    closeModal(){
        if (this.alteredHarvestShipping && !window.confirm("変更内容を破棄します。よろしいですか？")) {
        return;
        }
        this.alteredHarvestShipping = false;
        this.$emit('update:isShowHarvestShippingModal', false);
    }

    
    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if(document.body.classList.contains('newsSide')){
            document.body.classList.remove('newsSide')
        }else{
            document.body.classList.add('newsSide')
        }
    }

    inputChangedcheck(){
        if(this.alteredHarvestShipping==true){
            const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
            if(confirm){
                this.alteredHarvestShipping = false
            }
        }
    }
         
}      